const apiPaths = {
  getCancelFlow: '/locations/questionnaires?locationName=cancel-flow',
  getQuestionnaireAnswers: '/answers/users/self/questionnaires',
  getShoppingCredit: '/api/1/credits/campaigns/default',
  getDynamicText: '/preference/self/text',
  postQuestionnaireAnswers: '/answers',
  postCancelSubscription: '/answers/actions/cancelSubscription',
  putReactivateSubscription: '/answers/actions/reactivateSubscription',
  getCustomizeCampaignData: '/customize/self/campaign-state',
  getAccountInfo: '/users/self/accounts',
  getCancelCreditEligible: '/api/1/cancel-credit/is-eligible',
  postCancelCredit: '/api/1/cancel-credit',
  getProductsSelfData: '/v1/subscriptions/self',
  getSubscribableProducts: '/api/1/products/refillable/self',
};

export { apiPaths };
